import { render, staticRenderFns } from "./prompt-media-selection.vue?vue&type=template&id=26893c64"
import script from "./prompt-media-selection.vue?vue&type=script&lang=js"
export * from "./prompt-media-selection.vue?vue&type=script&lang=js"
import style0 from "./prompt-media-selection.vue?vue&type=style&index=0&id=26893c64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports